import React from 'react';

export interface IConfig {
  checkPermit: (permit: string) => boolean;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AppPermissions = React.createContext<IConfig>(undefined!);
